import script from "./upTime.vue?vue&type=script&setup=true&lang=js"
export * from "./upTime.vue?vue&type=script&setup=true&lang=js"

import "./upTime.vue?vue&type=style&index=0&id=d37991fc&lang=scss&scoped=true"
import "./upTime.vue?vue&type=style&index=1&id=d37991fc&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d37991fc"]])

export default __exports__